export default {
    meta: {
        title: '拓店宝-搜索场地库'
    }
};
